import React from "react";

interface SvgIconProps {
  size?: number;
  color?: string;
  style?: React.CSSProperties;
  className?: string;
}

export const Icon16Recents: React.FC<SvgIconProps> = ({
  size = 16,
  color = "currentColor",
  style,
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    className={className}
  >
    <path
      d="M2 8C2 8.78793 2.15519 9.56815 2.45672 10.2961C2.75825 11.0241 3.20021 11.6855 3.75736 12.2426C4.31451 12.7998 4.97595 13.2417 5.7039 13.5433C6.43185 13.8448 7.21207 14 8 14C8.78793 14 9.56815 13.8448 10.2961 13.5433C11.0241 13.2417 11.6855 12.7998 12.2426 12.2426C12.7998 11.6855 13.2417 11.0241 13.5433 10.2961C13.8448 9.56815 14 8.78793 14 8C14 6.4087 13.3679 4.88258 12.2426 3.75736C11.1174 2.63214 9.5913 2 8 2C6.4087 2 4.88258 2.63214 3.75736 3.75736C2.63214 4.88258 2 6.4087 2 8Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 5V8.28125L10.25 10.25"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Icon16Trash: React.FC<SvgIconProps> = ({
  size = 16,
  color = "currentColor",
  style,
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    className={className}
  >
    <path
      d="M2.5 4.66667H13.5M6.625 7.33333V11.3333M9.375 7.33333V11.3333M3.1875 4.66667L3.875 12.6667C3.875 13.0203 4.01987 13.3594 4.27773 13.6095C4.53559 13.8595 4.88533 14 5.25 14H10.75C11.1147 14 11.4644 13.8595 11.7223 13.6095C11.9801 13.3594 12.125 13.0203 12.125 12.6667L12.8125 4.66667M5.9375 4.66667V2.66667C5.9375 2.48986 6.00993 2.32029 6.13886 2.19526C6.2678 2.07024 6.44266 2 6.625 2H9.375C9.55734 2 9.7322 2.07024 9.86114 2.19526C9.99007 2.32029 10.0625 2.48986 10.0625 2.66667V4.66667"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Icon16Library: React.FC<SvgIconProps> = ({
  size = 16,
  color = "currentColor",
  style,
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    className={className}
  >
    <path
      d="M7.99965 1.89844L13.9993 5.25566V11.1084C13.9993 11.3703 13.9282 11.6276 13.793 11.8544C13.6579 12.0813 13.4636 12.2696 13.2295 12.4006L8.76943 14.8968C8.53539 15.0278 8.2699 15.0968 7.99965 15.0968C7.7294 15.0968 7.46391 15.0278 7.22987 14.8968L2.76978 12.4006C2.53574 12.2696 2.3414 12.0813 2.20627 11.8544C2.07115 11.6276 2.00001 11.3703 2 11.1084V5.25566L7.99965 1.89844Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99749 5V8.69959M7.99749 8.69959L5 10.4324M7.99749 8.69959L10.9987 10.4324"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** Folder icon from assets/Icons16/library.svg */
export const Icon16LibraryFile: React.FC<SvgIconProps> = ({
  size = 16,
  color = "currentColor",
  style,
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    className={className}
  >
    <path
      d="M6.10024 4.37531C5.91047 4.13809 5.62316 4 5.31938 4H3.2C2.54 4 2.006 4.50625 2.006 5.125L2 11.875C2 12.4938 2.54 13 3.2 13H12.8C13.46 13 14 12.4938 14 11.875V6.625C14 6.00625 13.46 5.5 12.8 5.5H7.24031C7.08842 5.5 6.94476 5.43096 6.84988 5.31235L6.10024 4.37531Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** Search icon from assets/Icons16/search.svg */
export const Icon16Search: React.FC<SvgIconProps> = ({
  size = 16,
  color = "currentColor",
  style,
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    className={className}
  >
    <path
      d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.9995 13.9995L11.1328 11.1328"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/**
 * Check icon from assets/Icons24/Icon 25.svg
 * Unselected: Icon 25.svg 그대로 (white 10% fill, grey #78787C checkmark)
 * Selected: Figma - solid primary50 circle + white checkmark
 */
export const Icon24CheckCircle: React.FC<
  SvgIconProps & { checked?: boolean; checkColor?: string }
> = ({
  size = 24,
  color = "currentColor",
  checked = true,
  checkColor,
  style,
  className,
}) => {
  // 비선택: Icon 25.svg 원본 (white 10%, grey #78787C check)
  // 선택: Figma - solid primary50 (#50b786) circle + white checkmark
  const circleFill = checked ? color : "#FFFFFF";
  const circleFillOpacity = checked ? 1 : 0.1;
  const pathStroke = checked ? (checkColor ?? "#78787C") : "#78787C";

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      className={className}
    >
      {/* Icon 25.svg: 원형 배경 + 체크마크 (항상 동일 형태) */}
      <rect
        x="2"
        y="2"
        width="20"
        height="20"
        rx="10"
        fill={circleFill}
        fillOpacity={circleFillOpacity}
      />
      <path
        d="M16 9L10.963 15L8 12"
        stroke={pathStroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

/** Upload icon from assets/Icons16/upload.svg */
export const Icon16Upload: React.FC<SvgIconProps> = ({
  size = 16,
  color = "currentColor",
  style,
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    className={className}
  >
    <path
      d="M1.99902 8.18126L1.99902 13.2727C1.99902 13.6727 2.33652 14 2.74902 14L13.249 14C13.6615 14 13.999 13.6727 13.999 13.2727L13.999 8.18126"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99902 10.3672L7.99902 2.00274"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.36621 4.54688L7.99121 2.00117L10.6162 4.54687"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconCloud: React.FC<SvgIconProps> = ({
  size = 24,
  color = "currentColor",
  style,
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    className={className}
  >
    <path
      d="M6.79545 19C5.46212 19 4.32955 18.5509 3.39773 17.6526C2.46591 16.7543 2 15.6625 2 14.3772C2 13.2379 2.37879 12.2373 3.13636 11.3756C3.89394 10.5138 4.85606 9.99531 6.02273 9.82003C6.32576 8.40323 7.03788 7.2457 8.15909 6.34742C9.2803 5.44914 10.5758 5 12.0455 5C13.7424 5 15.1742 5.5952 16.3409 6.7856C17.5076 7.976 18.0909 9.40376 18.0909 11.0689V11.5947C19.1818 11.5655 20.1061 11.9051 20.8636 12.6135C21.6212 13.3219 22 14.2165 22 15.2973C22 16.3052 21.6212 17.1742 20.8636 17.9045C20.1061 18.6348 19.2045 19 18.1591 19H6.79545Z"
      fill={color}
    />
  </svg>
);

/**
 * Design system `Icon24` / `Navi Left arrow` (node `40:8056`).
 *
 * chevron vector는 8x15이고 24x24 프레임 안에서 왼쪽 끝(x=0)에 붙은 채 세로만
 * 가운데 정렬된다(y=4.5). 24 프레임을 그대로 두어야 옆 요소와의 간격이 Figma와
 * 같아지므로, vector 크기로 잘라내지 않고 프레임째 그린다.
 */
export const Icon24NaviLeftArrow: React.FC<SvgIconProps> = ({
  size = 24,
  color = "currentColor",
  style,
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    className={className}
  >
    <path
      transform="translate(0 4.5)"
      d="M7.69408 0.330173C7.88996 0.541647 8 0.828428 8 1.12745C8 1.42648 7.88996 1.71326 7.69408 1.92473L2.52205 7.50681L7.69408 13.0889C7.88441 13.3016 7.98972 13.5864 7.98734 13.8821C7.98496 14.1778 7.87508 14.4606 7.68135 14.6697C7.48763 14.8788 7.22557 14.9974 6.95161 15C6.67765 15.0025 6.41372 14.8889 6.21666 14.6834L0.305919 8.30409C0.110039 8.09261 0 7.80583 0 7.50681C0 7.20779 0.110039 6.921 0.305919 6.70953L6.21666 0.330173C6.4126 0.118763 6.67831 0 6.95537 0C7.23243 0 7.49814 0.118763 7.69408 0.330173Z"
      fill={color}
    />
  </svg>
);

/**
 * Design system `Icon24` / `Icon=Upload, Type=Line` (node `6529:80509`).
 *
 * 24 프레임 안에서 tray vector는 16x5로 (4, 15)에 놓이고, arrow vector는 9.177x11.575로
 * 180도 회전된 채 오른쪽 아래 모서리가 (16.59375, 15.578125)에 맞춰진다. Figma의 원본
 * path를 그대로 두고 transform으로만 배치해 좌표가 DS와 어긋나지 않게 한다.
 *
 * Icon24 라이브러리는 단일 placeholder 색으로 배포되므로 색은 사용하는 화면에서
 * 정하고, 여기서는 `fill`을 `color` prop에 위임한다.
 */
export const Icon24Upload: React.FC<SvgIconProps> = ({
  size = 24,
  color = "currentColor",
  style,
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    className={className}
  >
    <path
      transform="translate(4 15)"
      d="M2 5C1.45 5 0.979333 4.80434 0.588 4.413C0.196666 4.02167 0.000666667 3.55067 0 3V1C0 0.71667 0.0960001 0.479337 0.288 0.288004C0.48 0.0966702 0.717333 0.000670115 1 3.44827e-06C1.28267 -0.000663218 1.52033 0.0953369 1.713 0.288004C1.90567 0.48067 2.00133 0.718003 2 1V3H14V1C14 0.71667 14.096 0.479337 14.288 0.288004C14.48 0.0966702 14.7173 0.000670115 15 3.44827e-06C15.2827 -0.000663218 15.5203 0.0953369 15.713 0.288004C15.9057 0.48067 16.0013 0.718003 16 1V3C16 3.55 15.8043 4.021 15.413 4.413C15.0217 4.805 14.5507 5.00067 14 5H2Z"
      fill={color}
    />
    <path
      transform="translate(16.59375 15.578125) rotate(180)"
      d="M4.21346 11.513C4.33013 11.5543 4.45513 11.575 4.58846 11.575C4.72179 11.5757 4.84679 11.555 4.96346 11.513C5.08013 11.471 5.18846 11.4 5.28846 11.3L8.88846 7.7C9.08913 7.5 9.18513 7.26667 9.17646 7C9.16779 6.73334 9.07179 6.5 8.88846 6.3C8.68913 6.09934 8.45179 5.995 8.17646 5.987C7.90113 5.979 7.66346 6.075 7.46346 6.275L5.58846 8.15V1C5.58979 0.718003 5.49413 0.48067 5.30146 0.288004C5.1088 0.0953369 4.87113 -0.000663218 4.58846 3.44827e-06C4.30579 0.000670115 4.06846 0.0966702 3.87646 0.288004C3.68446 0.479337 3.58846 0.71667 3.58846 1V8.15L1.71346 6.275C1.51413 6.07567 1.27679 5.98 1.00146 5.988C0.726128 5.996 0.488461 6.1 0.288461 6.3C0.104461 6.5 0.00846154 6.73334 0.00046154 7C-0.00753846 7.26667 0.0884612 7.5 0.288461 7.7L3.88846 11.3C3.98846 11.4007 4.09679 11.4717 4.21346 11.513Z"
      fill={color}
    />
  </svg>
);
